// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContentContainer_contentContainer__X5vZZ {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1400px;
}

@media (max-width: 1400px) {
  .ContentContainer_contentContainer__X5vZZ {
    max-width: 1100px;
  }
}
@media (max-width: 1100px) {
  .ContentContainer_contentContainer__X5vZZ {
    max-width: 800px;
  }
}
@media (max-width: 800px) {
  .ContentContainer_contentContainer__X5vZZ {
    padding: 0 4vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/ContentContainer/ContentContainer.module.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AACD;;AAEA;EACC;IACC,iBAAA;EACA;AACF;AAEA;EACC;IACC,gBAAA;EAAA;AACF;AAGA;EACC;IACC,cAAA;EADA;AACF","sourcesContent":[".contentContainer {\n\tmargin: 0 auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tmax-width: 1400px;\n}\n\n@media (max-width: 1400px) {\n\t.contentContainer {\n\t\tmax-width: 1100px;\n\t}\n}\n\n@media (max-width: 1100px) {\n\t.contentContainer {\n\t\tmax-width: 800px;\n\t}\n}\n\n@media (max-width: 800px) {\n\t.contentContainer {\n\t\tpadding: 0 calc(100vw / 375 * 15);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `ContentContainer_contentContainer__X5vZZ`
};
export default ___CSS_LOADER_EXPORT___;
